/** parseSampleFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parseSampleFilters = (params /* URLSearchParams */) => ({
  // Filters
  from: params.get("from"), // ISO date/time string, or key for `dateTimeProducer` fn
  to: params.get("to"), // ISO date/time string, or key for `dateTimeProducer` fn
  object_id: params.get("object_id"),
  id_cnts: params.get("id_cnts"), // id contains this string somewhere
})
